import store from "../redux/store";
import { serviceErrorOccured } from "../redux/actions/serviceNotificationActions";

class FetchWrapper {
  constructor(route, config) {
    this.route = route;
    this.config = config;
    this.errorHandlers = {};
  }

  withStartedHandler(startedHandler) {
    this.startedHandler = startedHandler;
    return this;
  }

  withSuccessHandler(successHandler) {
    this.successHandler = successHandler;
    return this;
  }

  withDefaultErrorHandler(errorHandler) {
    this.errorHandler = errorHandler;
    return this;
  }

  withCustomErrorHandler(statusCode, errorHandler) {
    this.errorHandlers = this.errorHandlers || {};
    this.errorHandlers[statusCode] = errorHandler;
    return this;
  }

  withCustomErrorMessageKey(errorText) {
    this.defaultError = { errorKey: this.errorText };
    return this;
  }

  async start() {
    if (!this.route.startsWith("http://")) {
      this.errorHandler("CheckConnection");
      return;
    }

    if (this.startedHandler) {
      this.startedHandler();
    }
    let response;
    try {
      response = await fetch(this.route, this.config);
    } catch (e) {
      this.errorHandler && this.errorHandler(response, 503);
      return;
    }
    if (
      (response.status >= 200 && response.status < 300) ||
      response.status === 304
    ) {
      try {
        let jsonResult = await response.json();
        this.successHandler(jsonResult);
      } catch (e) {
        this.successHandler();
      }
    } else {
      let errorResult = await response.text();

      if (this.errorHandlers[response.status]) {
        this.errorHandlers[response.status](errorResult);
      } else if (this.errorHandler) {
        this.errorHandler(errorResult);
      }
    }
  }
}

class ConventionFetch {
  constructor(createFetchWrapper) {
    this.createFetchWrapper = createFetchWrapper;
  }

  withActionType(actionType) {
    this.actionType = actionType;
    return this;
  }

  prepare({
    proccessSuccessJson,
    startedActionExtraParams = {},
    succeedActionExtraParams = {},
    failedActionExtraParams = {}
  } = {}) {
    let startedActionName = `${this.actionType}_STARTED`;
    let succeedActionName = `${this.actionType}_SUCCEED`;
    let failedActionName = `${this.actionType}_FAILED`;

    let fw = this.createFetchWrapper();
    fw.withStartedHandler(() =>
      store.dispatch({
        type: startedActionName,
        ...startedActionExtraParams
      })
    )
      .withSuccessHandler(responseJson => {
        let processedJson = proccessSuccessJson
          ? proccessSuccessJson(responseJson)
          : responseJson;

        store.dispatch({
          type: succeedActionName,
          data: processedJson,
          ...succeedActionExtraParams
        });
      })
      .withDefaultErrorHandler((errorText, statusCode) => {
        let errorResult = {};
        if (statusCode === 503) {
          errorResult = { errorKey: "CheckConnection" };
        } else if (errorText) {
          try {
            errorResult = JSON.parse(errorText);
          } catch (e) {}
        } else if (failedActionExtraParams.errorKey) {
          errorResult = {
            errorKey: failedActionExtraParams.errorKey
          };
        } else {
          errorResult = { errorKey: "UnexpectedPosError" };
        }

        store.dispatch(serviceErrorOccured(errorResult));
        store.dispatch({
          type: failedActionName,
          ...failedActionExtraParams
        });
      });

    return fw;
  }
}

export function fetchWrapper(route, config) {
  return new FetchWrapper(route, config);
}

export function conventionFetch(route, config) {
  return new ConventionFetch(() => fetchWrapper(route, config));
}

export function addMessageKeyToAction(prefix) {
  return {
    succeedActionExtraParams: { messageKey: prefix + "Succeeded" },
    failedActionExtraParams: { errorKey: prefix + "Failed" }
  };
}



// WEBPACK FOOTER //
// ./src/utils/fetchWrapper.js